import { Component } from '@verndale/core';
import PageTabs from './PageTabs';

class PageTransition extends Component {
  setupDefaults() {
    this.dom = {
      box: this.el.querySelector('.transtion-left-right-wrap'),
      toggleSliderButtons: this.el.querySelectorAll('.slide-button'),
      leftPane: this.el.querySelector('.left-pane')
    };

    new PageTabs(this.el);
  }

  addListeners() {
    this.dom.toggleSliderButtons.forEach(button =>
      button.addEventListener('click', this.togglePage.bind(this))
    );
    this.dom.leftPane.addEventListener('click', this.close.bind(this));
    this.el.addEventListener('openPanel', this.open.bind(this));
    this.el.addEventListener('closePanel', this.close.bind(this));
  }

  open() {
    window.scrollTo(0, 0);
    this.dom.box.classList.add('slide-content');
    this.dom.toggleSliderButtons.forEach(button =>
      button.classList.add('slide-content-open')
    );
  }

  close() {
    if (this.dom.box.classList.contains('slide-content')) {
      window.scrollTo(0, 0);
      this.dom.box.classList.remove('slide-content');
      this.dom.toggleSliderButtons.forEach(button =>
        button.classList.remove('slide-content-open')
      );
    }
  }

  togglePage(e) {
    e.stopPropagation();
    if (this.dom.box.classList.contains('slide-content')) {
      this.close();
    } else {
      this.open();
    }
  }
}

export default PageTransition;
